import * as React from 'react'
import { Form, Field, InjectedFormProps } from 'redux-form'
import { Input } from 'components/Input/Input'
import Button from 'components/Button'
import cn from 'classnames'
import * as sMarg from 'styles/modules/margins.scss'
import * as sLay from 'styles/modules/layout.scss'
import {
  INumberCreateFormData,
  IPhoneSystemNumberCreateFormProps,
} from 'features/PhoneSystem/PhoneSystemNumberCreateForm'
import { GetPhoneSystemServiceDocument, useCreatePhoneSystemNumberMutation } from 'src/generated/graphql'
import { PhoneSystemDidNumbersAvailableTable } from 'features/PhoneSystem/PhoneSystemDidNumbersAvailableTable'
import { vNotEmpty } from 'components/Input/Input.validations'

export type IPhoneSystemNumberCreateFormComponentProps = IPhoneSystemNumberCreateFormProps &
  InjectedFormProps<INumberCreateFormData>

export const PhoneSystemNumberCreateFormComponent = (
  props: IPhoneSystemNumberCreateFormComponentProps
) => {
  const { submitting, handleSubmit, onAfterSubmit, isNumberSelected } = props
  const [createPhoneSystemNumber] = useCreatePhoneSystemNumberMutation()

  return (
    <Form
      onSubmit={handleSubmit(async variables => {
        variables.number = variables.selectedNumbers ? variables.selectedNumbers[0].number : ''

        await createPhoneSystemNumber({
          variables,
          refetchQueries: [
            {
              query: GetPhoneSystemServiceDocument,
              variables: { id: props.initialValues.phoneSystemId },
            },
          ],
          awaitRefetchQueries: true,
        })
        onAfterSubmit()
      })}
    >
      <Field name="customerReference" label="Name" component={Input} validate={[vNotEmpty]} />

      <Field
        name="selectedNumbers"
        component={PhoneSystemDidNumbersAvailableTable}
        maxDIDNumbers={1}
      />

      <div className={cn(sLay['layout-column'], sLay['layout-align-center-center'], sMarg.mt30)}>
        <Button
          color="tertiary"
          loading={submitting}
          disabled={submitting || !isNumberSelected}
          type="submit"
        >
          Assign
        </Button>
      </div>
    </Form>
  )
}



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemNumberCreateForm/PhoneSystemNumberCreateForm.tsx